// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmptyInbox-textLead-jehef {
	color: var(--primary-foreground);
	line-height: 1.1;
}

.EmptyInbox-widthImg-sENRy {
	width: 200px;
}

.EmptyInbox-textCenter-iRqtY {
	text-align: center;
	color: var(--secondary-foreground);
	max-width: 396px;
	margin: 20px auto;
	font-size: 18px;
}

.EmptyInbox-textMuted-XrKJH {
	margin: 20px 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Inbox/EmptyInbox/EmptyInbox.css"],"names":[],"mappings":"AAAA;CACC,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,kCAAkC;CAClC,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,cAAc;AACf","sourcesContent":[".textLead {\n\tcolor: var(--primary-foreground);\n\tline-height: 1.1;\n}\n\n.widthImg {\n\twidth: 200px;\n}\n\n.textCenter {\n\ttext-align: center;\n\tcolor: var(--secondary-foreground);\n\tmax-width: 396px;\n\tmargin: 20px auto;\n\tfont-size: 18px;\n}\n\n.textMuted {\n\tmargin: 20px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textLead": `EmptyInbox-textLead-jehef`,
	"widthImg": `EmptyInbox-widthImg-sENRy`,
	"textCenter": `EmptyInbox-textCenter-iRqtY`,
	"textMuted": `EmptyInbox-textMuted-XrKJH`
};
module.exports = ___CSS_LOADER_EXPORT___;
